let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("eyC2i")).then(() => parcelRequire('3wJyD'));